var React = require('react');

function IcCloseComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-close"},React.createElement("path",{"id":"Vector","d":"M17.8741 7.33366L16.6993 6.16699L12 10.8337L7.30071 6.16699L6.12589 7.33366L10.8252 12.0003L6.12589 16.667L7.30071 17.8337L12 13.167L16.6993 17.8337L17.8741 16.667L13.1748 12.0003L17.8741 7.33366Z","fill":"#3E3E3E"})));
}

IcCloseComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcCloseComponent;

IcCloseComponent.default = IcCloseComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MobileModalV2/images/ic-close.component.svg
// module id = 1625
// module chunks = 0